//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props:[''],
    data: function () {
        return {
           
        }
    },
    
    methods: {
        // 拨打电话
      callTel(){
        var phone='400-901-6886'
        const a = document.createElement("a");
        a.href = "tel:"+phone+""
        a.click();
      },
      //发布项目
      publish(){
        this.$router.push({
            path:'/release/index?releaseType=3'
        })
      },
    },
    mounted: function () {
        
    }
}
